<div class="dialog-header">
  <h6>Additional Vessel Details</h6>
  <mat-icon color="warn" (click)="closeDialog()">close</mat-icon>
</div>


<div class="modalContainer">
  <mat-chip-grid *ngIf="data.vessel_fields?.length > 0; else noData">
    <mat-chip *ngFor="let field of data.vessel_fields" color="primary" selected>
      {{ field.field_name }}
    </mat-chip>
  </mat-chip-grid>
  <ng-template #noData>
    <p style="text-align: center;">No Additional field found</p>
  </ng-template>
</div>